// tslint:disable:no-commented-code
// tslint:disable:only-arrow-functions

import { IDynamicBindableValue } from '@epicuro-next/models/platform/dynamic-elements/dynamic-elements';

import { LoadingStateWrapper } from './loading-state-wrapper-helpers';

export function getServingConfigProperty(
  provider: string = 'self',
  property: string = 'loadingStateWrapper',
): { servingConfig: IDynamicBindableValue } {
  return {
    servingConfig: {
      provider,
      property,
      transform: function (loadingStateWrapper: LoadingStateWrapper) {
        if (loadingStateWrapper.isLoading) {
          return undefined;
        }

        const data = loadingStateWrapper.data as {
          servingConfig: string;
        };

        return data?.servingConfig;
      }.toString(),
    },
  };
}

export const servingconfigPropertyName: keyof ReturnType<
  typeof getServingConfigProperty
> = 'servingConfig';
